export default function ImagePreviewModal({
  isOpen,
  onClose,
  image,
}: {
  isOpen: boolean;
  onClose: () => void;
  image: string;
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300"
        onClick={onClose}
      />

      
      <div className="relative max-w-[90vw] max-h-[90vh] animate-fadeIn">
        <img
          src={image}
          alt="Preview"
          className="rounded-xl shadow-2xl max-w-full max-h-[90vh] object-contain"
        />

        
        <button
          onClick={onClose}
          className="absolute top-3 right-3 bg-black/60 text-white px-3 py-1 rounded-full text-sm hover:bg-black/80 transition"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
